export const fedfUploadObjektliste = {
  formdefinition: [
    {
      control: "input",
      name: "vertrag",
      label: "Vertrag",
      cols: "12",
      disabled: "true",
    },
    {
      control: "upload",
      name: "objektliste",
      label: "Objektliste",
      allowedExtensions: ["XLSX"],
      cols: "12",
      valid: "isNotEmpty(item)",
    },
  ],
  transformOut: [],
};
